import { render } from "./spip.vue?vue&type=template&id=4bcdba08"
import script from "./spip.vue?vue&type=script&lang=js"
export * from "./spip.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__